declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '@/views/login.vue'
import home from '@/views/home/home.vue'
import main from '@/views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('@/components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn',
    },
    component: () => import('@/views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', permission: 'Pages', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') }
    ]
}
export const appRouters: Array<Router> = [{
    path: '/setting',
    name: 'setting',
    permission: 'Pages.Administration',
    meta: { title: '系统设置' },
    icon: 'md-settings',
    component: main,
    children: [
        //  { path: 'role', permission: 'Pages.Administration.Roles', meta: { title: '角色管理' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
        { path: 'manager', permission: 'Pages.Administration.Manages', meta: { title: '管理员' }, name: 'manager', component: () => import('../views/setting/manager/manage.vue') },
        // { path: 'tenant', permission: 'Pages.Administration.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') },
        { path: 'classificationType', permission: 'Pages.Administration.ClassificationTypes', meta: { title: '分类类型' }, name: 'classificationType', component: () => import('../views/setting/classificationType/classificationType.vue') },
        { path: 'multiCategory', permission: 'Pages.Administration.MultiLevelCategorys', meta: { title: '多级分类' }, name: 'multiCategory', component: () => import('../views/setting/multiCategory/multiCategory.vue') },
        { path: 'keyword', permission: 'Pages.Administration.Dictionarys', meta: { title: '字典管理' }, name: 'keyword', component: () => import('../views/setting/keywords/keyword.vue') },
        { path: 'chapterType', permission: 'Pages.Administration.ChapterTypes', meta: { title: '章节管理' }, name: 'chapterType', component: () => import('../views/setting/chapterTypes/chapterType.vue') },
        { path: 'advertising', permission: 'Pages.Administration', meta: { title: '广告管理' }, name: 'advertising', component: () => import('../views/setting/advertising/advertising.vue') },
    ]
},
{
    path: '/member',
    name: 'member',
    permission: 'Pages.Members',
    meta: { title: '会员管理' },
    icon: 'md-person',
    component: main,
    children: [
        { path: 'user', permission: 'Pages.Members.Users', meta: { title: '用户管理' }, name: 'user', component: () => import('../views/member/user/user.vue') },
        { path: 'importuser', permission: 'Pages.Members.ImportUsers', meta: { title: '导入用户' }, name: 'importuser', component: () => import('../views/member/user/importuser.vue') },
        { path: 'payment', permission: 'Pages.Administration', meta: { title: '充值管理' }, name: 'payment', component: () => import('../views/member/member/payment.vue') },
        { path: 'consumptions', permission: 'Pages.Administration', meta: { title: '消费记录' }, name: 'consumptions', component: () => import('../views/member/consumptions/consumptions.vue') },
        { path: 'income', permission: 'Pages.Administration', meta: { title: '收入记录' }, name: 'income', component: () => import('../views/member/consumptions/income.vue') },
    ]
},
{
    path: '/articles',
    name: 'articles',
    permission: 'Pages.Articles',
    meta: { title: '文章管理' },
    icon: 'md-calendar',
    component: main,
    children: [
        { path: 'article', permission: 'Pages.Articles.Article', meta: { title: '文章管理' }, name: 'article', component: () => import('../views/articles/article/article.vue') },
        { path: 'auditArticle', permission: 'Pages.Articles.AuditArticle', meta: { title: '文章审核' }, name: 'auditArticle', component: () => import('../views/articles/article/auditArticle.vue') },
        // { path: 'placedtop', permission: 'Pages.Administration', meta: { title: '文章置顶' }, name: 'placedtop-article', component: () => import('../views/articles/article/placedtop-article.vue') }, 
        { path: 'learningCourse', permission: 'Pages.Articles.LearningCourse', meta: { title: '课程管理' }, name: 'learningCourse', component: () => import('../views/articles/learningCourses/learningCourse.vue') },
        { path: 'learningUsCourse', permission: 'Pages.Articles.UniversityCourse', meta: { title: '高校课程' }, name: 'learningUsCourse', component: () => import('../views/articles/learningUsCourse/learningUsCourse.vue') },
        { path: 'auditLearning', permission: 'Pages.Articles.LearningCourse', meta: { title: '课程审核' }, name: 'auditLearning', component: () => import('../views/articles/learningCourses/auditLearning.vue') },
        { path: 'oneQuestionPerday', permission: 'Pages.Articles.OneQuestionPerday', meta: { title: '每日一题' }, name: 'oneQuestionPerday', component: () => import('../views/articles/oneQuestionPerdays/oneQuestionPerday.vue') },
        // { path: 'placedtopPerday', permission: 'Pages.Administration', meta: { title: '置顶每日一题' }, name: 'placedtopPerday', component: () => import('../views/articles/oneQuestionPerdays/placedtop-oneQuestionPerday.vue') },
    ]
},
{
    path: '/resources',
    name: 'resources',
    permission: 'Pages.Resources',
    meta: { title: '资源管理' },
    icon: 'ios-open',
    component: main,
    children: [
        { path: 'resource', permission: 'Pages.Resources.Resource', meta: { title: '资源管理' }, name: 'resource', component: () => import('../views/resources/resource/resource.vue') },
        { path: 'hiresource', permission: 'Pages.Resources.University', meta: { title: '高校资源' }, name: 'hiresource', component: () => import('../views/resources/resource/hiresource.vue') },
        // { path: 'placedTopResource', permission: 'Pages.Administration', meta: { title: '资源置顶' }, name: 'placedTopResource', component: () => import('../views/resources/resource/placedtop-resource.vue') },
        { path: 'auditResource', permission: 'Pages.Resources.AuditResource', meta: { title: '资源审核' }, name: 'auditResource', component: () => import('../views/resources/resource/auditResource.vue') },
    ]
},
{
    path: '/testQuestions',
    name: 'testQuestions',
    permission: 'Pages.Questions',
    meta: { title: '题库管理' },
    icon: 'ios-people',
    component: main,
    children: [
        { path: 'testQuestion', permission: 'Pages.Questions.TestQuestion', meta: { title: '试题管理' }, name: 'testQuestion', component: () => import('../views/testQuestions/testQuestion/testQuestion.vue') },
        { path: 'importestQuestion', permission: 'Pages.Questions.ImportTestQuestion', meta: { title: '导入试题' }, name: 'importestQuestion', component: () => import('../views/testQuestions/testQuestion/impor_testQuestion.vue') },
        { path: 'testQuestionUs', permission: 'Pages.Questions.UniversityQuestion', meta: { title: '高校试题' }, name: 'testQuestionUs', component: () => import('../views/testQuestions/testQuestion/testQuestionUs.vue') },
        { path: 'testQuestionCensus', permission: 'Pages.Questions.Statistical', meta: { title: '试题统计' }, name: 'testQuestionCensus', component: () => import('../views/testQuestions/testQuestion/testQuestionCensus.vue') },
        { path: 'testQuestionTeacher', permission: 'Pages.Questions.Teachers', meta: { title: '教师试题' }, name: 'testQuestionTeacher', component: () => import('../views/testQuestions/testQuestion/testQuestionTeacher.vue') },

    ]
},
{
    path: '/testPapers',
    name: 'testPapers',
    permission: 'Pages.TestPapers',
    meta: { title: '试卷管理' },
    icon: 'md-pie',
    component: main,
    children: [
        { path: 'testPaper', permission: 'Pages.TestPapers.Hand', meta: { title: '人工组卷' }, name: 'testPaper', component: () => import('../views/testPapers/testPaper/testPaper.vue') },
        { path: 'testPaperUs', permission: 'Pages.TestPapers.UniversityHand', meta: { title: '高校人工' }, name: 'testPaperUs', component: () => import('../views/testPapers/testPaper/testPaperUs.vue') },
        { path: 'randomPaper', permission: 'Pages.TestPapers.Random', meta: { title: '随机组卷' }, name: 'randomPaper', component: () => import('../views/testPapers/testPaper/randomPaper.vue') },
        { path: 'randomPaperUs', permission: 'Pages.TestPapers.UniversityRandom', meta: { title: '高校随机' }, name: 'randomPaperUs', component: () => import('../views/testPapers/testPaper/randomPaperUs.vue') },
        { path: 'auditedTestPaper', permission: 'Pages.Administration.Manages', meta: { title: '试卷审核' }, name: 'auditedTestPaper', component: () => import('../views/testPapers/testPaper/AuditedTestPaper.vue') },
        // { path: 'homeWork', permission: 'Pages.TestPapers.Homework', meta: { title: '人工作业' }, name: 'homeWork', component: () => import('../views/testPapers/testPaper/homeWork.vue') },
        //  { path: 'auditedHomeWork', permission: 'Pages.Administration.Manages', meta: { title: '作业审核' }, name: 'auditedHomeWork', component: () => import('../views/testPapers/testPaper/AuditedHomeWork.vue') },
    ]
},

{
    path: '/workPapers',
    name: 'workPapers',
    permission: 'Pages.Homeworks',
    meta: { title: '作业管理' },
    icon: 'md-baseball',
    component: main,
    children: [
        // { path: 'testPaper', permission: 'Pages.TestPapers.TestPaper', meta: { title: '人工组卷' }, name: 'testPaper', component: () => import('../views/testPapers/testPaper/testPaper.vue') },
        // { path: 'auditedTestPaper', permission: 'Pages.Administration.Manages', meta: { title: '试卷审核' }, name: 'auditedTestPaper', component: () => import('../views/testPapers/testPaper/AuditedTestPaper.vue') },
        { path: 'homeWork', permission: 'Pages.Homeworks.Hand', meta: { title: '人工作业' }, name: 'homeWork', component: () => import('../views/workPapers/workPaper/homeWork.vue') },
        { path: 'randomWork', permission: 'Pages.Homeworks.Random', meta: { title: '随机作业' }, name: 'randomWork', component: () => import('../views/workPapers/workPaper/randomWork.vue') },
        { path: 'auditedHomeWork', permission: 'Pages.Administration.Manages', meta: { title: '作业审核' }, name: 'auditedHomeWork', component: () => import('../views/workPapers/workPaper/AuditedHomeWork.vue') },
    ]
},
{
    path: '/miscellaneous',
    name: 'miscellaneous',
    permission: 'Pages.Others',
    meta: { title: '其他管理' },
    icon: 'ios-school',
    component: main,
    children: [
        { path: 'friendlyLink', permission: 'Pages.Others.FriendlyLink', meta: { title: '友情链接' }, name: 'friendlyLink', component: () => import('../views/miscellaneous/friendlyLinks/friendlyLink.vue') },
        { path: 'siteMessage', permission: 'Pages.Others.SiteMessage', meta: { title: '网站留言' }, name: 'siteMessage', component: () => import('../views/miscellaneous/siteMessage/siteMessage.vue') },
        { path: 'discuss', permission: 'Pages.Others.Discuss', meta: { title: '会员评论' }, name: 'discuss', component: () => import('../views/miscellaneous/discusses/discuss.vue') },
        { path: 'leaveMessage', permission: 'Pages.Others.LeaveMessage', meta: { title: '相互留言' }, name: 'leaveMessage', component: () => import('../views/miscellaneous/leaveMessage/leaveMessage.vue') },
        { path: 'questionnaire', permission: 'Pages.Others.Questionnaire', meta: { title: '问卷调查' }, name: 'questionnaire', component: () => import('../views/miscellaneous/questionnaires/questionnaire.vue') },
        { path: 'answerquestion', permission: 'Pages.Others.Answerquestion', meta: { title: '在线答疑' }, name: 'answerquestion', component: () => import('../views/miscellaneous/answerquestions/answerquestion.vue') },
    ]
}
]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
